export const BASE_URL="https://uatapi.bintix.com/api/v1";
export const PORTAL_URL="https://uat-portal.bintix.com";